export const GET_SOCIETIES = 'GET_SOCIETIES';
export const GET_SOCIETIES_SUCCESS = 'GET_SOCIETIES_SUCCESS';
export const GET_SOCIETIES_ERROR = 'GET_SOCIETIES_ERROR';
export const GET_SOCIETY_DETAILS = 'GET_SOCIETY_DETAILS';
export const GET_SOCIETY_DETAILS_SUCCESS = 'GET_SOCIETY_DETAILS_SUCCESS';
export const GET_SOCIETY_DETAILS_ERROR = 'GET_SOCIETY_DETAILS_ERROR';
export const DOWNLOAD_BILLING_STATEMENT = 'DOWNLOAD_BILLING_STATEMENT';
export const DOWNLOAD_BILLING_STATEMENT_SUCCESS = 'DOWNLOAD_BILLING_STATEMENT_SUCCESS';
export const DOWNLOAD_BILLING_STATEMENT_ERROR = 'DOWNLOAD_BILLING_STATEMENT_ERROR';
